import { service } from '@ember/service';
import { setOwner } from '@ember/application';

export default class WebsocketActivityHandlersMessage {
  @service messaging;
  @service messagingConversation;
  @service store;

  constructor(owner) {
    setOwner(this, owner);
  }

  handleActivity(response) {
    this.#handleMessageActivity(response.payload);
  }

  #handleMessageActivity(payload) {
    const message = this.store.normalize('messaging-message', payload.data);
    const {
      data: { attributes, relationships },
    } = message;
    const conversationId = relationships.conversation.data.id;

    let localRecord;
    if (attributes.localId) {
      localRecord = this.store
        .peekAll('messaging-message')
        .find(record => record.localId === attributes.localId);
    }

    const isFromCurrentConversation =
      this.messagingConversation.selectedConversation?.id === conversationId;
    const record = localRecord || this.store.push(message);

    if (isFromCurrentConversation && !localRecord) {
      this.messagingConversation.messages.unshiftObject(record);
    }

    if (!attributes.isSystem && !attributes.deletedAt) {
      this.#updateConversationLastMessage(conversationId, record);
      if (!attributes.isOwn) {
        this.#addUnreadConversation(conversationId);
      }
    }
  }

  #updateConversationLastMessage(conversationId, message) {
    const conversation = this.store.peekRecord('messaging-conversation', conversationId);
    conversation.updatedAt = new Date();
    conversation.lastMessage = message;
  }

  #addUnreadConversation(conversationId) {
    this.messaging.currentProfile.addUnreadConversation(conversationId);
  }
}
